/**
 * BrewNectar FAQ — accessible accordion + staggered fade-up
 */
(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initFadeUp(section) {
    var animated = section.querySelectorAll('.bn-faq__animate');

    if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
      animated.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var rootMargin = section.getAttribute('data-bn-faq-observer-margin') || '-60px 0px';
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: rootMargin, threshold: 0 }
    );

    animated.forEach(function (el) {
      observer.observe(el);
    });
  }

  function setItemOpen(item, open) {
    var trigger = item.querySelector('[data-bn-faq-trigger]');
    var panel = item.querySelector('[data-bn-faq-panel]');
    if (!trigger || !panel) return;

    item.classList.toggle('is-open', open);
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  function initAccordion(section) {
    var allowMultiple = section.getAttribute('data-bn-faq-allow-multiple') === 'true';
    var items = section.querySelectorAll('[data-bn-faq-item]');
    var triggers = section.querySelectorAll('[data-bn-faq-trigger]');

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-bn-faq-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        if (!allowMultiple) {
          items.forEach(function (other) {
            if (other !== item) setItemOpen(other, false);
          });
        }

        setItemOpen(item, !isOpen);
      });
    });

    section.addEventListener('keydown', function (e) {
      var triggerList = Array.prototype.slice.call(triggers);
      var index = triggerList.indexOf(document.activeElement);
      if (index === -1) return;

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        var next = triggerList[Math.min(index + 1, triggerList.length - 1)];
        if (next) next.focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        var prev = triggerList[Math.max(index - 1, 0)];
        if (prev) prev.focus();
      } else if (e.key === 'Home') {
        e.preventDefault();
        if (triggerList[0]) triggerList[0].focus();
      } else if (e.key === 'End') {
        e.preventDefault();
        if (triggerList[triggerList.length - 1]) triggerList[triggerList.length - 1].focus();
      }
    });
  }

  function initSection(section) {
    if (!section || section.dataset.bnFaqInit === 'true') return;
    section.dataset.bnFaqInit = 'true';

    initFadeUp(section);
    initAccordion(section);
  }

  function initAll() {
    document.querySelectorAll('.bn-faq').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.bn-faq');
    if (section) initSection(section);
  });
})();
